module.exports = __webpack_public_path__ + "img/a2c4bca.png";